export default __webpack_public_path__ + "static/media/rs_text_icon.7d0ceabc.svg";